import { useSuspenseQuery } from '@apollo/client'
import { GetMyInfosDocument } from '@/core/graphql/sdk'
import { GetMyInfosQuery } from '@/core/graphql/types'

export function useMyInfosLoader() {
  const { data } = useSuspenseQuery<GetMyInfosQuery>(GetMyInfosDocument)

  return data?.myInfos
}
